export default __webpack_public_path__ + "static/logo-white-e1eaa280597168c012399b5cd69fdbdd.svg";